import { BASE_URL } from '../configs/config';
import Auth from '../libs/auth-wrapper';
import { apiFetch } from '../libs/apiFetch';

export const sendReceipt = async (orderId: string, type: string) => {
  try {
    const idToken = await Auth.getIdToken();

    const res = await apiFetch(`${BASE_URL}sendReceipt/${orderId}?type=${type}`, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
    });
    return res;
  } catch (error) {
    return null;
  }
};
